<template>
    <div>
        <img @click="goto()" src="~@/assets/activity.png" style="width: 100%" alt="">
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Activity',
    data(){
        return {
        }
    },
    computed: {

    },
    created(){
    },
    methods: {
        goto(){
            this.$router.push("/Ucenter");
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/Activity.vue